import { trackEvent, TrackingObject } from 'dibs-tracking';

import { getCurrentAccountType } from '../../../utils/userTrackingHelpers/getCurrentAccountType';

import { ACTION_COMPLETE } from './sharedAuthTracking';

export function loginTracking({ action, label, value, additional = {} }: TrackingObject): void {
    if (action === ACTION_COMPLETE) {
        additional = {
            ...additional,
            currentAccountType: getCurrentAccountType({ type: 'password' }),
        };
    }

    trackEvent({
        action: `login ${action}`,
        category: 'login',
        label,
        value,
        additional,
    });
}
